import React from 'react';
import settingsStyles from '../settingsStyles';

// Durum rozeti. tone: 'ok' | 'warn' | 'off' | 'brand'
export default function StatusPill({tone = 'off', label, withDot = true}) {
    const classes = settingsStyles();

    const toneClass = {
        ok: classes.pillOk,
        warn: classes.pillWarn,
        off: classes.pillOff,
        brand: classes.pillBrand,
    }[tone] || classes.pillOff;

    return (
        <span className={`${classes.pill} ${toneClass}`}>
            {withDot && <span className={classes.pillDot} />}
            {label}
        </span>
    );
}
